<div class="spinner appear">
    <ion-spinner name="lines" [color]="color"></ion-spinner>
  </div>
